import { render, staticRenderFns } from "./StatusPill.vue?vue&type=template&id=f26d42b8&scoped=true"
import script from "./StatusPill.vue?vue&type=script&lang=ts"
export * from "./StatusPill.vue?vue&type=script&lang=ts"
import style0 from "./StatusPill.vue?vue&type=style&index=0&id=f26d42b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26d42b8",
  null
  
)

export default component.exports